<template>
  <div class="position-relative">
    <div class="box-thead-sticky">
      <div class="box-action-all">
        <div>
          <button v-if="checkShowDeleteButton" @click="handleDeleteAllItems()" class="btn btn-warning w-200">選択した商品を削除</button>
          <button v-if="checkShowDeleteButton" @click="handleChangeAmountReceived()" class="btn btn-primary w-300">
            <i v-if="isBasicPlan" class="fa fa-lock text-warning" aria-hidden="true"></i>
            選択した商品の受取金額を一括変更
          </button>
        </div>
        <div class="flexbox gap-10">
          <button v-if="isChangeItems" @click="handleChangeAllItems()" class="btn btn-warning">すべて保存</button>
          <pagination
            :totalPage="totalPage"
            :currentPage="currentPage"
            :maxRows="maxRows"
            @updateCurrentPage="updateCurrentPage"
            @updateMaxRows="updateMaxRows"
          />
        </div>
      </div>
    </div>
    <div class="box-thead-sticky-2">
      <div class="table-wrapper-sticky" id="table-wrapper-sticky">
        <div class="table-wrapper hide-scrollbar" @scroll="handleScrollTheadSticky($event)">
          <table class="table table-bordered common-table">
            <thead class="" id="product-table-header">
              <tr class="align-middle">
                <th
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="column.headerClass"
                  :id="`sticky-header-product-`+ index"
                  :style="{width: column.width, 'min-width' : column.minWidth, 'max-width' : column.maxWidth}"
                  @click="handleClickHeader(column)"
                  v-html="`${column.label}`"
                >
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
    <div class="table-wrapper" @scroll="handleScrollTheadSticky($event)">
      <table class="table table-bordered common-table" style="margin-top: 17px;">
        <thead class="thead-not-visibility">
          <tr class="align-middle">
            <th
              v-for="(column, index) in columns"
              :key="index"
              :class="column.headerClass"
              :id="column.field"
              :style="{width: column.width, 'min-width' : column.minWidth, 'max-width' : column.maxWidth}"
              @click="handleClickHeader(column)"
              v-html="`${column.label}`"
            >
            </th>
          </tr>
        </thead>
        <tbody class="tbody-visibility">
          <tr v-if="!initial && !filterAllDataCount">
            <td :colspan="columns.length" align="center" class="bg-danger text-danger" style="background-color: #f2dede">
              <h5 class="font-bold">データが見つかりません。</h5>
            </td>
          </tr>
          <template v-else v-for="(groupedRow, index) in groupedRows">
            <tr :key="`grouped-row-` + index" :class="[rowStyleClassFn(groupedRow), !groupedRow.isParent ? 'product-record' : '']">
              <template v-if="groupedRow.isParent">
                <td
                  v-for="(column, colIndex) in columns"
                  v-if="isDisplayParentData(column.name)"
                  :colspan="column.name === 'deleteCheckBox' ? 1 : columns.length - 1"
                  :key="colIndex"
                  :class="column.cellClass"
                  :style="{width: column.width}"
                >
                  <slot :name="column.name" :row-data="groupedRow" :handle-data="handleData" :data="pageData" :original-data="originalData" :is-group-table="false"></slot>
                  <button v-if="column.name === 'productName'" type="button" class="btn-collapse-expand btn-expand" @click="handleClickRow($event, groupedRow)">
                    <i class="fa fa-caret-down collapse-icon" :class="`collapse-icon-parent-${groupedRow.asin}`" aria-hidden="true"></i>
                    <span class="collapse-text">バリエーションを表示</span>
                  </button>
                </td>
              </template>
              <template v-else>
                <td
                  v-for="(column, colIndex) in columns"
                  :key="colIndex"
                  :class="column.cellClass"
                  :style="{width: column.width}"
                >
                  <slot :name="column.name" :row-data="groupedRow" :handle-data="handleData" :data="pageData" :original-data="originalData" :is-group-table="false"></slot>
                </td>
              </template>
            </tr>
            <template v-if="groupedRow.isParent && groupedRow.children.length">
              <tr
                v-for="(childrenRow, childrenRowIndex) in groupedRow.children"
                :key="groupedRow.asin +`-children-` + childrenRowIndex"
                :class="`collapse collapse-${groupedRow.asin} ${childrenRowStyleClassFn(childrenRow)} product-record`"
                :id="`collapse-${groupedRow.asin}-${childrenRowIndex}`"
              >
                <td
                  v-for="(subColumn, subColIndex) in columns"
                  :key="subColIndex"
                  :class="subColumn.cellClass"
                  :style="{width: subColumn.width}"
                >
                  <slot :name="subColumn.name" :row-data="childrenRow" :handle-data="handleData" :data="pageData" :original-data="originalData" :is-group-table="true"></slot>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <get-data
      :url="this.url"
      :extraUrl="this.extraUrl"
      :extraUrlMode="this.extraUrlMode"
      @onChangePage="onChangePage"
      @zIndex="$emit('zIndex', $event)"
      @originalData="getOriginalData"
      :filters="this.filters"
      :needExtraData="needExtraData"
      :maxRows="maxRows"
      :currentPage="currentPage"
      :loadingTableMode="loadingTableMode"
      :method="method"
      @fetchedDataLoading="$emit('fetchedDataLoading')"
      @updateCurrentPage="updateCurrentPage"
      ref="pagination"
    />
    <pagination
      v-if="pageData.length >= 50"
      class="flex mr-t-20"
      :totalPage="totalPage"
      :currentPage="currentPage"
      :maxRows="maxRows"
      @updateCurrentPage="updateCurrentPage"
      @updateMaxRows="updateMaxRows"
    />
  </div>
</template>
<script>
import Pagination from '@/components/PaginationNextPage'
import GetData from './GetData'
import DatePicker from 'vue2-datepicker'
import ProductService from '@/services/productservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    DatePicker,
    GetData,
    Pagination
  },
  data () {
    return {
      initial: true,
      pageData: [],
      defaultData: [],
      originalData: [],
      collapseExpandedAsins: {},
      countCollapse: 0,
      groupedRows: [],
      groupedByParent: [],
      groupedByHasScOffer: [],
      groupedByHasAcrossOffer: [],
      enableCloseAllCollapseProduct: true,
      checkAll: false,
      filterAllDataCount: 0,
      totalPage: 1,
      currentPage: 1,
      maxRows: 50,
      isLoadMore: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    needExtraData: {
      type: Boolean,
      default: false
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array
    },
    method: {
      type: String,
      default: 'get'
    },
    filters: {
      type: Object,
      default () {
        return {
          keyword: '',
          judgmentStatus: '',
          amountReceived: '',
          stockStatus: '',
          warehouse: ['Amazon', 'salmonAcross', 'salmonSc'],
          hasSellmonScOffers: false
        }
      }
    },
    checkedItems: {
      type: Array,
      default () {
        return []
      }
    },
    isChangeItems: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allParents () {
      const allParents = this.$refs.pagination.allParents
      const objectAllParents = {}
      allParents.forEach(item => {
        objectAllParents[item.asin] = item
      })
      return objectAllParents
    },
    checkShowDeleteButton () {
      return this.checkedItems.length !== 0
    },
    isBasicPlan () {
      return this.$store.getters.getUser.memberPlan === '0'
    }
  },
  created () {
    this.totalPage = Math.ceil(this.filterAllDataCount / this.maxRows)
  },
  methods: {
    handleClickRow (event, row) {
      let asin = row.asin
      if (!row.isParent) {
        return
      }
      const classList = event.currentTarget.classList
      const icon = event.currentTarget.querySelector('.collapse-icon')
      const text = event.currentTarget.querySelector('.collapse-text')
      if (classList.contains('btn-collapse')) {
        classList.remove('btn-collapse')
        classList.add('btn-expand')
        icon.classList.remove('fa-caret-up')
        icon.classList.add('fa-caret-down')
        text.textContent = 'バリエーションを表示'
      } else if (classList.contains('btn-expand')) {
        classList.remove('btn-expand')
        classList.add('btn-collapse')
        icon.classList.remove('fa-caret-down')
        icon.classList.add('fa-caret-up')
        text.textContent = 'バリエーションを非表示'
      }
      let collapseParentSelector = $(`.collapse-${asin}`)
      collapseParentSelector.collapse('toggle')
      let collapseChildFirstSelector = $(`#collapse-${asin}-0`)
      collapseChildFirstSelector.on('shown.bs.collapse', () => {
        this.countCollapse++
        if (this.countCollapse === 1) {
          this.toggleExpandRecord(row)
        }
        if (!this.collapseExpandedAsins[asin]) {
          this.collapseExpandedAsins[asin] = asin
        }
        this.enableCloseAllCollapseProduct = false
      })
      collapseChildFirstSelector.on('hidden.bs.collapse', () => {
        delete this.collapseExpandedAsins[asin]
        this.countCollapse = 0
      })
      setTimeout(() => {
        this.resetHeaderTabProduct()
        this.countCollapse = 0
      }, 400)
    },
    async toggleExpandRecord (row) {
      let paramParentAsin = row.asin
      let hasUpdateData = 'no'
      await ProductService.getGroupProducts({
        parent_asin: paramParentAsin
      }).then((data) => {
        if (data.length) {
          hasUpdateData = 'yes'
          let allData = this.$refs.pagination.allData
          let objectAllAsins = {}
          let oldProductAsins = []
          allData.filter((dataItem, dataIndex) => {
            objectAllAsins[dataItem.asin] = dataItem.asin
            if (dataItem.asin === paramParentAsin || dataItem.parentAsin === paramParentAsin) {
              oldProductAsins.push(dataItem)
            }
          })
          oldProductAsins = oldProductAsins.map(item => item.asin)

          let newProductAsins = {}

          for (let allDataIndex = 0; allDataIndex < allData.length; allDataIndex++) {
            for (let responseDataIndex = 0; responseDataIndex < data.length; responseDataIndex++) {
              let product = allData[allDataIndex]
              let productData = data[responseDataIndex]
              if (product.asin === paramParentAsin && productData.asin === paramParentAsin) {
                this.$refs.pagination.allData[allDataIndex] = productData
                this.$refs.pagination.originalData[allDataIndex] = productData
              } else if (productData.parentAsin === paramParentAsin && productData.asin === product.asin) {
                this.$refs.pagination.allData[allDataIndex] = productData
                this.$refs.pagination.originalData[allDataIndex] = productData
              } else if (productData.parentAsin === paramParentAsin && !objectAllAsins[productData.asin]) {
                if (!newProductAsins[productData.asin]) {
                  this.$refs.pagination.allData.push(productData)
                  this.$refs.pagination.originalData.push(productData)
                  newProductAsins[productData.asin] = productData.asin
                }
              }
            }
          }
          this.$refs.pagination.fetchDataClientMode('expandParentRecord', oldProductAsins)
        }
      }).catch((err) => {
        this.$store.commit('toggleModal', {
          show: true,
          message: err
        })
      })

      let logParams = {
        name: eventCode.manage_products.list_tab.expand_product_parent,
        properties: {
          parentAsin: paramParentAsin,
          hasUpdateData: hasUpdateData
        }
      }
      EventService.postTrackLog(logParams)
    },
    reload () {
      this.$refs.pagination.reload()
    },
    getOriginalData (data) {
      this.originalData = [...data]
    },
    isDisplayParentData (name) {
      return ['deleteCheckBox', 'productName'].includes(name)
    },
    handleData (item, type) {
      this.$refs.pagination.handleData(item, type)
    },
    onChangePage (data, extraData, filterAllDataCount) {
      if (this.needExtraData) {
        this.$emit('extraData', extraData)
      }

      this.filterAllDataCount = filterAllDataCount
      this.$emit('countData', this.$refs.pagination.allData.length - this.$refs.pagination.allParents.length)
      this.$emit('filterAllDataCount', this.filterAllDataCount)
      this.totalPage = Math.ceil(this.filterAllDataCount / this.maxRows)
      this.defaultData = [...data]
      this.pageData = this.defaultData.slice(0, 100)
      this.groupedRows = this.formatGroupedRows(this.pageData)
      if (this.initial) {
        this.initial = false
      }
      setTimeout(() => {
        const variationDisplaySetting = this.$store.getters.getUser.variationDisplaySetting
        this.toggleAllCollapseProduct(0, this.groupedRows, variationDisplaySetting)
      }, 300)
      this.isLoadMore = false
    },
    loadMoreData () {
      if (this.isLoadMore) {
        return false
      }
      const scrollPosition = window.innerHeight + window.scrollY
      const bottomPosition = document.documentElement.scrollHeight
      if (bottomPosition / 2 - scrollPosition < 0) {
        this.isLoadMore = true
        const loadDataRow = 100
        const startIndex = this.pageData.length
        if (startIndex >= this.defaultData.length) {
          return false
        }
        const endIndex = startIndex + loadDataRow
        const loadMoreData = [...this.defaultData].slice(startIndex, endIndex)
        setTimeout(() => {
          this.isLoadMore = false
        }, 500)
        this.pageData = [...this.pageData, ...loadMoreData]
        loadMoreData.length = 0
        const startToggle = this.groupedRows.length
        this.groupedRows = this.formatGroupedRows(this.pageData)
        if (this.initial) {
          this.initial = false
        }
        setTimeout(() => {
          const variationDisplaySetting = this.$store.getters.getUser.variationDisplaySetting
          this.toggleAllCollapseProduct(startToggle, this.groupedRows, variationDisplaySetting)
        }, 300)
      }
    },
    formatGroupedRows (pageData) {
      var groupedData = []
      this.groupedByParent.length = 0
      this.groupedByHasScOffer.length = 0
      this.groupedByHasAcrossOffer.length = 0
      let keywordValue = this.filters.keyword
      let judgmentStatusValue = this.filters.judgmentStatus
      let amountReceivedValue = this.filters.amountReceived
      let stockStatusValue = this.filters.stockStatus
      if ((!keywordValue || !keywordValue.trim()) && !judgmentStatusValue && !stockStatusValue && !amountReceivedValue && this.filters.warehouse.length === 3) {
        pageData.forEach((d) => {
          if (d.parentAsin === null) {
            groupedData.push(d)
          } else {
            const parent = this.allParents[d.parentAsin]
            if (parent) {
              groupedData.push(parent)
            }
          }
        })
        groupedData = groupedData.filter((value, index, array) => {
          return index === array.findIndex(t => t.asin === value.asin)
        })

        // 子asinを入れるcolumn作成
        groupedData.forEach((g) => {
          g.children = []
          if (g.isParent) {
            let parent = {}
            parent[g.asin] = []
            this.groupedByParent.push(parent)
          }
        })

        // 子asinをマッピング
        pageData.forEach((p) => {
          const matched = groupedData.find(g => g.asin === p.parentAsin)
          if (matched) {
            matched.children.push(p)
            let parent = this.groupedByParent.find((v) => Object.keys(v)[0] === p.parentAsin)
            parent[p.parentAsin].push(p.asin)
          }

          if (p.hasScOffer) {
            this.groupedByHasScOffer.push(p.asin)
          }
          if (p.hasAcrossOffer) {
            this.groupedByHasAcrossOffer.push(p.asin)
          }
        })
        // 子を持つ親asinの画像は最初の子の画像をセット
        groupedData.forEach((g) => {
          if (g.children.length) g.image = g.children[0].image
        })
      } else {
        groupedData = pageData.map(item => Object.assign(item, {children: []}))
      }
      return groupedData
    },
    // 子がある行は背景色をつける + 審査NG/出品NGの時は背景をつける
    rowStyleClassFn (row) {
      var bgClass = 'child'
      if (row.children && row.children.length === 0) {
        bgClass = 'not-child'
      }
      let judgmentStatusCode = row.judgmentStatusCode
      let deleteFlg = row.deleteFlg
      if (judgmentStatusCode !== null) {
        if (judgmentStatusCode === '8' || judgmentStatusCode === '9') {
          bgClass = bgClass + ' bg-danger'
        } else if (judgmentStatusCode === '2' && deleteFlg === '2') {
          bgClass = bgClass + ' bg-product-stopped'
        }
      }
      return bgClass
    },
    childrenRowStyleClassFn (childrenRow) {
      let bgClass = ''
      let judgmentStatusCode = childrenRow.judgmentStatusCode
      let deleteFlg = childrenRow.deleteFlg
      let parentAsin = childrenRow.parentAsin
      if (judgmentStatusCode !== null) {
        if (judgmentStatusCode === '8' || judgmentStatusCode === '9') {
          bgClass = bgClass + ' bg-danger'
        } else if (judgmentStatusCode === '2' && deleteFlg === '2') {
          bgClass = bgClass + ' bg-product-stopped'
        }
      }
      if (parentAsin && !!this.collapseExpandedAsins[parentAsin]) {
        bgClass = bgClass + ' in'
      }
      return bgClass
    },
    handleClickHeader (column) {
      if (column.name === 'deleteCheckBox') {
        this.checkAll = !this.checkAll
        this.$emit('checkBoxAll', this.checkAll)
      }
    },
    handleScrollTheadSticky (event) {
      $('#product-list .table-wrapper').scrollLeft(event.target.scrollLeft)
    },
    handleDeleteAllItems () {
      this.$emit('handleDeleteAllItems')
    },
    handleChangeAllItems () {
      this.$emit('handleChangeAllItems')
    },
    setWithHeaderTabProduct (headerClass) {
      let elm = document.getElementById(headerClass)
      if (elm) {
        let getBounding = elm.getBoundingClientRect()
        return getBounding.width + 'px'
      }
    },
    resetHeaderTabProduct () {
      let productHeaderIds = [
        'deleteCheckBox',
        'judgmentStatusCode',
        'productName',
        'action'
      ]
      productHeaderIds.forEach((productHeaderId, productHeaderIndex) => {
        let widthHeader = this.setWithHeaderTabProduct(productHeaderId)
        let selectorHeader = $('#sticky-header-product-' + productHeaderIndex)
        selectorHeader.css('width', widthHeader)
        selectorHeader.css('min-width', widthHeader)
        selectorHeader.css('max-width', widthHeader)
      })
    },
    toggleAllCollapseProduct (begin, data, variationDisplaySetting) {
      const variationDisplaySettingOn = '1'
      const variationDisplaySettingOff = '0'
      for (let i = begin; i < data.length; i++) {
        if (variationDisplaySetting === variationDisplaySettingOn) {
          const asin = data[i].asin
          $(`.collapse-${asin}`).addClass('in')
          $('#product-list .btn-collapse-expand').addClass('btn-collapse')
          $('#product-list .btn-collapse-expand').removeClass('btn-expand')
          $('#product-list .btn-collapse-expand .collapse-icon').addClass('fa-caret-up')
          $('#product-list .btn-collapse-expand .collapse-icon').removeClass('fa-caret-down')
          $('#product-list .btn-collapse-expand .collapse-text').text('バリエーションを非表示')
        }
        if (variationDisplaySetting === variationDisplaySettingOff && this.enableCloseAllCollapseProduct) {
          const asin = data[i].asin
          $(`.collapse-${asin}`).removeClass('in')
          $('#product-list .btn-collapse-expand').removeClass('btn-collapse')
          $('#product-list .btn-collapse-expand').addClass('btn-expand')
          $('#product-list .btn-collapse-expand .collapse-icon').removeClass('fa-caret-up')
          $('#product-list .btn-collapse-expand .collapse-icon').addClass('fa-caret-down')
          $('#product-list .btn-collapse-expand .collapse-text').text('バリエーションを表示')
        }
      }
    },
    handleChangeAmountReceived () {
      this.$emit('handleChangeAmountReceived', this.isBasicPlan)
    },
    updateCurrentPage (val) {
      this.currentPage = val
      this.checkAll = false
      this.$emit('checkBoxAll', this.checkAll)
      this.pageData.length = 0
      this.groupedRows.length = 0
    },
    updateMaxRows (val) {
      this.maxRows = val
      this.checkAll = false
      this.$emit('checkBoxAll', this.checkAll)
      this.groupedRows.length = 0
      this.pageData.length = 0
    }
  },
  watch: {
    checkedItems: {
      handler (arrCheckedItems) {
        const items = this.defaultData.filter((item) => { return !item.isParent })
        this.checkAll = this.checkedItems.length > 0 && this.checkedItems.length === items.length
        $('#product-delete-checkbox-all').prop('checked', this.checkAll)

        var hasSellmonScOffers = this.groupedByHasScOffer.some(ai => arrCheckedItems.includes(ai))
        var hasSellmonAcrossOffers = this.groupedByHasAcrossOffer.some(ai => arrCheckedItems.includes(ai))
        this.$emit('handleCheckSellmonScOffer', hasSellmonScOffers)
        this.$emit('handleCheckSellmonAcrossOffer', hasSellmonAcrossOffers)

        var parents = []
        this.groupedByParent.forEach((p) => {
          if (Object.values(p)[0].every(ai => arrCheckedItems.includes(ai))) {
            parents.push(Object.keys(p)[0])
          }
        })
        this.$emit('handleChangeParentCheckedItems', parents)
      },
      deep: true
    }
  },
  updated () {
    this.resetHeaderTabProduct()
  },
  mounted () {
    window.addEventListener('resize', this.resetHeaderTabProduct)
    window.addEventListener('scroll', this.loadMoreData)
  },
  unmouted () {
    window.removeEventListener('resize', this.resetHeaderTabProduct)
    window.removeEventListener('scroll', this.loadMoreData)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resetHeaderTabProduct)
    window.removeEventListener('scroll', this.loadMoreData)
  }
}
</script>
<style>
.bg-product-stopped {
  background-color: #d8d8d8;
}
</style>
<style scoped>
.common-table {
  font-size: 14px;
}
.common-table > tbody > tr:hover {
  background-color: unset;
}
.common-table > thead > tr > th {
  background-color: #deebf7;
  color: #595959;
}
.common-table > tbody > tr.child:hover {
  background-color: beige;
}
.common-table > tbody > tr.bg-product-stopped:hover {
  background-color: #d8d8d8;
}
.common-table > tbody > tr.bg-danger:hover {
  background-color: #f2dede;
}
.common-table th {
  font-weight: 800;
}
.common-table .child {
  background-color: beige;
  cursor: pointer;
}
.common-table tr.child tr.child td:nth-child(2)
,tr.child td:nth-child(4),tr.child td:nth-child(5),tr.child td:nth-child(6),tr.child td:nth-child(7) {
  border-left-color: beige;
}
tr.child td:nth-child(4) {
  border-right-color: beige;
}
.common-table tr td {
  vertical-align: top;
}
.common-table tr:not(.child, .not-child) td:first-child {
  background-color: beige;
}
.common-table tr.not-child td:nth-child(3){
  text-align: left !important;
}
.common-table tr:not(.child, .not-child) td:nth-child(3) {
  text-align: left !important;
}
.table-wrapper {
  width: unset;
  position: unset;
  overflow-x: auto;
  overflow-y: hidden;
}
/* Chrome */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.grouped-table-header {
  text-align: left;
}
.common-table .product-name {
  min-width: 450px;
  text-align: left;
}
.common-table .head-offer-price {
  text-align: right;
}
.common-table .head-number-of-stock {
  text-align: left;
}
.common-table /deep/ .box-label-number-of-stock {
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin: auto -8px;
  min-width: 440px;
}
.common-table /deep/ .box-label-number-of-stock .explan-icon {
  font-size: 25px;
  cursor: pointer;
}
.common-table .column-number-of-stock .sc-shipping {
  align-items: start;
}
.common-table .column-number-of-stock .line-seperate {
  margin: 10px -8px;
  border-color: #ddd;
}
.common-table .table-alert span {
  width: 185px;
}
.position-relative {
  position: relative;
}
.table-wrapper-sticky {
  overflow: hidden;
}
.thead-not-visibility {
  visibility: hidden;
}
.tbody-not-visibility {
  visibility: hidden;
}
.box-thead-sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 62px;
  z-index: 101;
}
.box-thead-sticky .box-action-all {
  height: 50px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 5px;
}
.box-thead-sticky .box-action-all .btn-warning {
  margin-right: 0;
  padding: 5px 30px;
  border-radius: 5px;
}
.box-thead-sticky-2 {
  position: sticky;
  position: -webkit-sticky;
  top: 112px;
  z-index: 99;
  margin-bottom: -57px;
}
.btn-collapse-expand {
  display: flex;
  align-items: center;
  font-weight: bolder;
  padding: 4px 6px;
  border-radius: 5px;
  margin-top: 10px
}
.btn-expand {
  border: 1px solid #008cc6;
  color: #008cc6;
  background-color: #ffffff;
}
.btn-collapse {
  border: 1px solid #808080;
  color: #fff;
  background-color: #808080;
}
.btn-collapse-expand .collapse-icon {
  font-size: 30px;
  font-style: normal;
  margin-right: 5px;
}
.btn-expand:hover {
  background-color: #008cc6;
  color: #ffffff;
}
.btn-collapse:hover {
  background-color: #fff;
  color: #808080;
}
.delete-button {
  vertical-align: middle !important;
}
.sticky {
  position: fixed;
  z-index: 10000;
  top: 110px;
  width: 100%;
}
@media (max-width: 1600px) {
  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
   }
  .common-table .product-name {
    min-width: 450px !important;
  }
}
@media (max-width: 768px) {
  .box-thead-sticky {
    top: 42px;
  }
}
@media (max-width: 576px) {
  .box-thead-sticky  .box-action-all .btn-warning {
    padding: 3px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/ProductGroupedTable.vue